// extracted by mini-css-extract-plugin
module.exports = {"cls1":"HomePage-CssProp1_th-module--cls1--1Hyy4","cls2":"HomePage-CssProp1_th-module--cls2--2JK-E HomePage-CssProp1_th-module--cls1--1Hyy4"};